import React from "react";
import styled from "@emotion/styled";

import ParkkiTheme from "themes/ParkkiTheme";

const Bar = styled.div`
  height: 64px;
  color: rgba(0, 0, 0, 0.87);
  position: relative;
  background-color: ${ParkkiTheme.colors.blue};
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  width: 100%;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
  display: flex;
  z-index: 70;
  padding-left: 24px;
`;

type Props = {
  children?: React.ReactNode;
};

function AppBar({ children }: Props): JSX.Element {
  return <Bar>{children}</Bar>;
}

export default AppBar;
